import { Box, Typography } from '@mui/material';
import { pxToRem, pxTovW } from '../../../commonUtils/resizeUtils';
import { IStyles } from '../../../commonUtils/styleUtils';
interface Iprops {
  checked: boolean;
  handleChange: () => void;
}
export const ToggleSwitch = (props: Iprops) => {
  const { checked, handleChange } = props;
  const transitionDuration = '0.3s'; // Set your desired transition duration

  const styles: IStyles = {
    box: {
      display: 'flex',
      flexDirection: 'row',
      border: checked ? '2px solid #0AA34F' : '2px solid #828282',
      width: { xs: pxToRem(121), md: pxTovW(140), lg: pxTovW(95) },
      height: { xs: pxToRem(46), md: pxTovW(55), lg: pxTovW(36) },
      justifyContent: 'space-around',
      background: checked ? '#E4FCEE' : '#F8F8F8',
      borderRadius: {
        xs: `${pxToRem(23)} !important`,
        md: `${pxToRem(23)} !important`,
      },
      cursor: 'pointer',
    },
  };
  return (
    <Box sx={styles.box} onClick={handleChange}>
      <Box
        sx={{
          width: { xs: pxToRem(19), md: pxTovW(19) },
          background: '#FFFFFF',
          height: { xs: pxToRem(19), md: pxTovW(19) },
          borderRadius: {
            xs: `${pxToRem(15)} !important`,
            md: `${pxToRem(15)} !important`,
          },
          marginY: 'auto',
          border: '3px solid #0AA34F',
          order: checked ? 2 : 1,
          // transition: `all ${transitionDuration} ease-in`,
        }}
      ></Box>
      <Box
        sx={{
          marginY: 'auto',
          order: checked ? 1 : 2,
          // transition: `all ${transitionDuration} ease-in`,
        }}
      >
        <Typography
          variant="h3"
          fontWeight={600}
          textAlign="left"
          sx={{
            fontSize: { xs: pxToRem(14), md: pxTovW(16) },
          }}
        >
          {checked ? 'YES' : 'NO'}
        </Typography>
      </Box>
    </Box>
  );
};
